var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0146 4.73828H13.9746V6.07422H12.0146V7.375H13.9746V8.71094H12.0146V13H10.3096L7.50586 8.71094H3.86719V13H2.17969V8.71094H0.272461V7.375H2.17969V6.07422H0.272461V4.73828H2.17969V0.203125H3.86719L6.8291 4.73828H10.3359V0.203125H12.0146V4.73828ZM3.86719 7.375H6.63574L5.7832 6.07422H3.86719V7.375ZM8.54297 7.375H10.3359V6.07422H7.69922L8.54297 7.375ZM3.86719 4.73828H4.91309L3.86719 3.13867V4.73828ZM10.3359 10.1084V8.71094H9.42188L10.3359 10.1084Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.16bc36e1e38bd13d10049b5335fa970b.svg";
export { ForwardRef as ReactComponent };